export type PresetKey =
  | "slate"
  | "rose"
  | "pink"
  | "purple"
  | "indigo"
  | "blue"
  | "cyan"
  | "teal"
  | "emerald"
  | "amber"
  | "orange"

export const COLOR_PRESETS: Record<
  PresetKey,
  { bg: string; text: string; border: string }
> = {
  slate: { bg: "#f8fafc", text: "#334155", border: "#94a3b8" },
  rose: { bg: "#fff1f2", text: "#9f1239", border: "#fda4af" },
  pink: { bg: "#fdf2f8", text: "#9d174d", border: "#f9a8d4" },
  purple: { bg: "#faf5ff", text: "#6b21a8", border: "#d8b4fe" },
  indigo: { bg: "#eef2ff", text: "#3730a3", border: "#a5b4fc" },
  blue: { bg: "#eff6ff", text: "#1e40af", border: "#93c5fd" },
  cyan: { bg: "#ecfeff", text: "#155e75", border: "#67e8f9" },
  teal: { bg: "#f0fdfa", text: "#115e59", border: "#5eead4" },
  emerald: { bg: "#ecfdf5", text: "#065f46", border: "#6ee7b7" },
  amber: { bg: "#fffbeb", text: "#92400e", border: "#fcd34d" },
  orange: { bg: "#fff7ed", text: "#9a3412", border: "#fdba74" },
}

export const PRESET_KEYS = Object.keys(COLOR_PRESETS) as PresetKey[]
